import React from 'react';

const EmptyStateScreen = ({ text }) => {
    return (
        <div className="min-w-full min-h-[70vh] bg-filterPannel-bg flex flex-col p-4 items-center justify-center gap-6">
            <p className="mb-4 text-text text-sm font-semibold text-center uppercase">{text}</p>
        </div>
    );
};

export default EmptyStateScreen;